export function findWatchlistPosition(stock, netPositions, lotVariant) {
  const stockId = String((stock && (stock.instrumentIdentifier || stock.id)) || '');
  const variant = String(lotVariant || 'MEGA').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
  const matches = Array.isArray(netPositions) ? netPositions : [];
  return matches.find((position) => {
    const id = String(position.stockId || position.instrumentIdentifier || '');
    const positionVariant = String(position.lotVariant || 'MEGA').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
    return id === stockId && positionVariant === variant;
  }) || null;
}

/**
 * Opposite-side click only. Same side and flat positions return null so the
 * existing open-order path stays in charge.
 */
export function planOppositeWatchlistOrder(position, side, quantity, isLimit) {
  if (!position) {
    return null;
  }
  const net = Number(position.netQty);
  const openNet = Number.isFinite(net)
    ? net
    : (Number(position.buyQty || 0) - Number(position.sellQty || 0));
  if (!Number.isFinite(openNet) || Math.abs(openNet) < 0.0001) {
    return null;
  }
  const openSide = openNet > 0 ? 1 : 2;
  if (Number(side) === openSide) {
    return null;
  }
  const openQty = Math.abs(openNet);
  const qty = Number(quantity) || 0;
  const closeQty = Math.min(qty, openQty);
  const extraQty = Math.max(0, qty - openQty);
  return {
    openQty,
    closeQty,
    extraQty,
    rejectLimitOverQty: !!isLimit && extraQty > 0.0001,
  };
}
